module.exports = __webpack_public_path__ + "scripts/spaceman.svg?a4a30b74";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/error/spaceman.svg
// module id = 1321
// module chunks = 1